<template>
    <form-wrapper @form-submit="submit">
        <form-row>
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.user.change_email.fields.email.label')"
                    :placeholder="$t('forms.user.change_email.fields.email.placeholder')"
                    :isRequired="false"
                    type="email"
                    name="hidden"
                    valuePath="email"
                    @change="changeEmail"
                ></text-input>
            </form-cell>
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.user.change_phone.fields.phone.label')"
                    :placeholder="$t('forms.user.change_phone.fields.phone.placeholder')"
                    :isRequired="true"
                    type="text"
                    name="hidden"
                    valuePath="mobile"
                    :isDisabled="disableForm && data.mobile"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>
        <form-row>
            <form-cell width="half">
                <text-input
                    :formData="data"
                    :label="$t('forms.user.profile.fields.first_name.label')"
                    :placeholder="$t('forms.user.profile.fields.first_name.placeholder')"
                    :isRequired="true"
                    type="text"
                    name="hidden"
                    :isDisabled="disableForm && data.firstName"
                    valuePath="firstName"
                    @change="change"
                ></text-input>
            </form-cell>
            <form-cell width="half">
                <text-input
                    :formData="data"
                    :label="$t('forms.user.profile.fields.last_name.label')"
                    :placeholder="$t('forms.user.profile.fields.last_name.placeholder')"
                    :isRequired="true"
                    type="text"
                    name="hidden"
                    :isDisabled="disableForm && data.lastName"
                    valuePath="lastName"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>
        <form-row>
            <form-cell>
                <select-input
                    :formData="data"
                    :label="$t('common.microcopy.language')"
                    :placeholder="$t('common.microcopy.language')"
                    :isRequired="true"
                    :options="languageOptions"
                    valuePath="language"
                    @change="change"
                ></select-input>
            </form-cell>
        </form-row>
        <template #footer>
            <common-content-spacer height="medium">
                <p v-if="showDescription">
                    {{ $t('pages.company.company_clients.info') }}
                </p>
                <common-buttons v-if="showSubmitButton">
                    <common-button type="primary" :label="$t('common.microcopy.save')"></common-button>
                </common-buttons>
            </common-content-spacer>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import CompanyAPI from 'api/CompanyAPI'
    import UsersAPI from 'api/UsersAPI'
    import debounce from 'lodash.debounce'
    import LanguageEnum from 'enums/language.enum'

    export default {
        mixins: [FormMixin],

        components: {},

        props: {
            showSubmitButton: { type: Boolean, default: true },
            companyId: { type: Number, default: undefined },
            showDescription: { type: Boolean, default: true },
            prefillClient: { type: Object, default: undefined },
        },

        data() {
            return {
                disableForm: false,
                languageOptions: Object.values(LanguageEnum).map((item) => {
                    return {
                        value: item,
                        label: item.toUpperCase(),
                    }
                }),
            }
        },

        methods: {
            submit() {
                const companyId = this.showSubmitButton ? this.$route.params.id : this.companyId
                this.prefillClient?.id ? this.editClient(companyId) : this.addClient(companyId)
            },

            addClient(companyId) {
                this.submitForm(
                    CompanyAPI.addClient(this.data, companyId).then((response) => {
                        this.$toast.success(this.$t('common.microcopy.success'))
                        this.emitEvent({ name: 'client-added', payload: response?.id })
                    }),
                ).catch((error) => {
                    if (error.error.message === 'USER.ALREADY_PART_OF_THE_COMPANY') {
                        this.emitEvent({ name: 'client-already-exist', payload: this.data })
                    }
                    if (error.statusCode === 400) {
                        this.$toast.error(this.$t(`validations.${error.error.message}`))
                    } else {
                        this.$toast.error(this.$t('common.errors.common_error'))
                    }
                })
            },

            editClient(companyId) {
                this.submitForm(
                    CompanyAPI.editClient(this.data, this.prefillClient.id, companyId).then((response) => {
                        this.$toast.success(this.$t('common.microcopy.success'))
                        this.emitEvent({ name: 'client-added', payload: response?.id })
                    }),
                ).catch((error) => {
                    if (error.error.message === 'USER.ALREADY_PART_OF_THE_COMPANY') {
                        this.emitEvent({ name: 'client-already-exist', payload: this.data })
                    }
                    if (error.statusCode === 400) {
                        this.$toast.error(this.$t(`validations.${error.error.message}`))
                    } else {
                        this.$toast.error(this.$t('common.errors.common_error'))
                    }
                })
            },

            changeEmail: debounce(function ({ path, value }) {
                this.change({ path, value })
                const pattern =
                    //eslint-disable-next-line
                    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                if (this.data.email.toLowerCase().match(pattern) && !this.prefillClient?.id) {
                    UsersAPI.getUserbyEmail(this.data.email)
                        .then((respone) => {
                            this.data.mobile = respone.mobile || undefined
                            this.data.firstName = respone.firstName || undefined
                            this.data.lastName = respone.lastName || undefined
                            this.disableForm = true
                        })
                        .catch(() => {
                            this.data.mobile = ''
                            this.data.firstName = ''
                            this.data.lastName = ''
                            this.disableForm = false
                        })
                }
            }, 500),
        },

        mounted() {
            this.data.language = this.$i18n.locale
            if (this.prefillClient?.id) {
                this.data.firstName = this.prefillClient.firstName
                this.data.lastName = this.prefillClient.lastName
                this.data.mobile = this.prefillClient.mobile
                this.data.email = this.prefillClient.email
            }
        },
    }
</script>
